import i18next from 'i18next';
export var requestTranslateFunction = function (key, options) {
    return options
        ? i18next.t("root:backend-errors." + key, options)
        : i18next.t("root:backend-errors." + key);
};
